/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ConstructionPlanAreaLocationBase } from "../../../../schema/generated/ConstructionPlanAreaLocation";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ConstructionPlanAreaLocationDataApi extends EntityDataApi<ConstructionPlanAreaLocationBase> {
  public readonly def = idbEntityDefs.ConstructionPlanAreaLocation;
}